import { isPayeeCentral, isVendorCentral } from "../config";

export const User = {
  STANDALONE: "STANDALONE",
  PAYEE: "PAYEE",
  VENDORCENTRAL: "VENDORCENTRAL",
} as const;
export type User = (typeof User)[keyof typeof User];

export function getUser(): User {
  if (isVendorCentral()) {
    return User.VENDORCENTRAL;
  } else if (isPayeeCentral()) {
    return User.PAYEE;
  }
  return User.STANDALONE;
}
